/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラーテーブルのソートキー種別を定義する
 * @graph-connects none
 */
export type SortKey = 'count' | 'uniqueSessions' | 'screen' | 'event';
/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business テーブルソートの昇順・降順方向を定義する
 * @graph-connects none
 */
export type SortDir = 'asc' | 'desc';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラー画面別テーブルのソート可能ヘッダー。現在のソートキーに矢印を出し、クリックで onSort を呼ぶ。
 * @graph-connects none
 */
export function SortHeader({
  label,
  sortKey: key,
  currentKey,
  dir,
  onSort,
  align = 'left',
}: {
  label: string;
  sortKey: SortKey;
  currentKey: SortKey;
  dir: SortDir;
  onSort: (key: SortKey) => void;
  align?: 'left' | 'right';
}) {
  const isActive = key === currentKey;
  const arrow = isActive ? (dir === 'desc' ? ' ▼' : ' ▲') : '';
  return (
    <th
      className={`py-2 px-2 text-[var(--color-text-muted)] font-medium cursor-pointer hover:text-[var(--color-text-primary)] select-none ${
        align === 'right' ? 'text-right' : 'text-left'
      }`}
      onClick={() => {
        onSort(key);
      }}
    >
      {label}
      {arrow}
    </th>
  );
}
